import React, {createContext, useCallback, useContext, useLayoutEffect, useRef, useState} from 'react'
import {createPortal} from 'react-dom'

const TooltipContext = createContext({show: () => {}, move: () => {}, hide: () => {}})

export const useTooltip = () => useContext(TooltipContext)

// Tooltip dùng chung, cách định vị giống bản mẫu (lệch 14px, lật khi chạm mép màn)
export const TooltipProvider = ({children}) => {
    const tipRef = useRef(null)
    const [tip, setTip] = useState({visible: false, content: null, x: 0, y: 0})

    const show = useCallback((event, content) => setTip({visible: true, content, x: event.clientX, y: event.clientY}), [])
    // Đọc clientX/clientY ngay ở đây: setTip dùng hàm cập nhật nên chạy trễ hơn, lúc đó
    // SyntheticEvent (React 16 dùng event pooling) đã bị null hoá các trường, đọc trong callback sẽ ra null.
    const move = useCallback((event) => {
        const {clientX, clientY} = event
        setTip(previous => ({...previous, x: clientX, y: clientY}))
    }, [])
    const hide = useCallback(() => setTip(previous => ({...previous, visible: false})), [])

    useLayoutEffect(() => {
        const el = tipRef.current
        if (!el) return

        const rect = el.getBoundingClientRect()
        let x = tip.x + 14
        let y = tip.y + 14
        if (x + rect.width > window.innerWidth - 8) x = tip.x - rect.width - 14
        if (y + rect.height > window.innerHeight - 8) y = tip.y - rect.height - 14

        el.style.left = `${x}px`
        el.style.top = `${y}px`
    }, [tip])

    return (
        <TooltipContext.Provider value={{show, move, hide}}>
            {children}
            {/* Gắn thẳng vào body: dashboard có phần tử cha dùng transform làm position: fixed lệch khỏi con trỏ */}
            {createPortal(
                <div ref={tipRef} className="NgRateTip" role="status" aria-live="polite" style={{opacity: tip.visible ? 1 : 0}}>
                    {tip.content}
                </div>,
                document.body
            )}
        </TooltipContext.Provider>
    )
}

export const tipHandlers = (tooltip, content) => ({
    onPointerEnter: (event) => tooltip.show(event, content),
    onPointerMove: tooltip.move,
    onPointerLeave: tooltip.hide,
})
